import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-up-right"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerUpRight"><path fillRule="evenodd" clipRule="evenodd" d="M4 20.2071V9.70711H19.2929L15.2929 13.7071L16 14.4142L21.2071 9.20711L16 4L15.2929 4.70711L19.2929 8.70711H3V20.2071H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerUpRight;
